
import { supabase } from "@/integrations/supabase/client";

export const signUp = async (email: string, password: string) => {
  const { error, data } = await supabase.auth.signUp({ email, password });
  
  if (error) {
    throw error;
  }
  
  return data;
};

export const signIn = async (email: string, password: string) => {
  const { error, data } = await supabase.auth.signInWithPassword({
    email,
    password,
  });

  if (error) {
    throw error;
  }

  return data;
};

export const signInWithGoogle = async () => {
  const origin = window.location.origin;
  const redirectTo = `${origin}/auth/callback`;
  
  const cleanOrigin = origin.endsWith('/') ? origin.slice(0, -1) : origin;
  const finalRedirectTo = `${cleanOrigin}/auth/callback`;
  
  const { error, data } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: finalRedirectTo,
    }
  });

  if (error) {
    throw error;
  }

  return data;
};

export const signOut = async () => {
  try {
    // Primeiro, verificar se há uma sessão ativa
    const { data: sessionData } = await supabase.auth.getSession();
    
    if (!sessionData.session) {
      // Se não há sessão, apenas limpar o estado local
      return;
    }
    
    // Tentar logout com escopo local primeiro
    const { error: localError } = await supabase.auth.signOut({ scope: 'local' });
    
    if (localError) {
      // Se o logout local falhar, tentar logout global
      const { error: globalError } = await supabase.auth.signOut({ scope: 'global' });
      
      if (globalError) {
        // Se ambos falharem, forçar limpeza local
        await supabase.auth.signOut({ scope: 'local' });
        
        // Limpar localStorage manualmente como fallback
        if (typeof window !== 'undefined') {
          localStorage.removeItem('sb-dnnkhfhqbobhhzdqktzb-auth-token');
        }
        
        // Não lançar erro para não bloquear o usuário
        return;
      }
    }
    
  } catch (error: any) {
    // Em caso de erro inesperado, forçar limpeza local
    try {
      await supabase.auth.signOut({ scope: 'local' });
      if (typeof window !== 'undefined') {
        localStorage.removeItem('sb-dnnkhfhqbobhhzdqktzb-auth-token');
      }
    } catch (cleanupError) {
      // Handle error silently
    }
    
    // Não lançar erro para não bloquear o usuário
  }
};
